import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import * as _ from 'lodash-es';

@Injectable({
  providedIn: 'root'
})
export class MaintenanceOwnerService {

  constructor(private http: HttpClient) { }

  saveMaintenanceOwner(
    baseUrl: string,
    maintenanceOwnerData: any[],
    clobSettings: any[],
    globalService: any,
    filterParams: any = {},
    rowData: any = {}
  ): Observable<any> {
    const url = baseUrl + "/saveJsonObject?action_code=2dg949";

    // 🔴 CRITICAL: Build payload EXACTLY like original AngularJS with proper fallbacks
    let params = _.merge({}, globalService || {}, filterParams);

    // Essential parameters with fallbacks
    params.clob_settings = JSON.stringify(clobSettings);
    params.clob_data = JSON.stringify(maintenanceOwnerData);
    params.tax_year = filterParams.tax_year || params.tax_year;
    params.scenario = filterParams.scenario || params.scenario;
    params.jcd_key = filterParams.jcd_key || params.jcd_key || 250; // AngularJS factory fallback
    params.scenarioCode = filterParams.scenarioCode || filterParams.scenario_code || params.scenarioCode || "RAF";
    params.is_issue_key_enabled = "N";
    params.process_name = "Basket Post 965";

    // 🔴 Remove checkLockedbj from save call (only needed for delete)
    delete params.checkLockedbj;

    // 🔴 MUST use application/x-www-form-urlencoded (NOT application/json)
    const urlEncoded = new URLSearchParams();
    Object.keys(params).forEach(key => {
      if (params[key] !== undefined && params[key] !== null) {
        urlEncoded.set(key, params[key].toString());
      }
    });

    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded'
    });

    return this.http.post<any>(url, urlEncoded.toString(), { headers, withCredentials: true });
  }

  deleteMaintenanceOwner(
    baseUrl: string,
    rowData: any,
    clobSettings: any[],
    ssoId: string,
    globalService: any,
    filterParams: any = {}
  ): Observable<any> {
    const url = baseUrl + "/saveJsonObject?action_code=rtt2wc";

    // 🔴 CRITICAL: Build payload EXACTLY like original AngularJS with proper fallbacks
    let params = _.merge({}, globalService || {}, filterParams);

    // Essential parameters with fallbacks
    const jsonSettings = JSON.stringify(clobSettings);
    const clob_data = JSON.stringify(rowData);

    params.clob_data = clob_data;
    params.filing_key = filterParams.filing_key || params.filing_key;
    params.sso_id = ssoId;
    params.tax_year = filterParams.tax_year || params.tax_year;
    params.scenario = filterParams.scenario || params.scenario;
    params.jcd_key = filterParams.jcd_key || params.jcd_key || 250;
    params.scenarioCode = filterParams.scenarioCode || filterParams.scenario_code || params.scenarioCode || "RAF";
    params.is_issue_key_enabled = "N";

    // 🔴 Add checkLockedbj parameter for locking validation
    // Construct from rowData if globalService doesn't already have it
    if (!params.checkLockedbj && rowData.PARENT_ME_CODE && params.scenario) {
      const checkLockedbj = [{
        me_code: rowData.PARENT_ME_CODE,
        scenario_key: params.scenario
      }];
      params.checkLockedbj = JSON.stringify(checkLockedbj);
    }

    console.log('MaintenanceOwner delete params:', params);

    // 🔴 MUST use application/x-www-form-urlencoded (NOT application/json)
    const urlEncoded = new URLSearchParams();
    Object.keys(params).forEach(key => {
      if (params[key] !== undefined && params[key] !== null) {
        urlEncoded.set(key, params[key].toString());
      }
    });

    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded'
    });

    return this.http.post<any>(url, urlEncoded.toString(), { headers, withCredentials: true });
  }
}


